import '../css/chart.css'
import { ReactComponent as BiChartSvg } from "../assets/biChartSvg"


export const BiChart = (props: any) => {

return  (
    <>
   
        <div className="chart-container">
  
        <BiChartSvg
            centerX = '475'
            centerY = '475'
            signRadius = '645'
            signBorderRadius = '526'
            outerRadius = '570'
            innerRadius = '380'
            houseRadius = '205'
            centerRadius = '110'
            DegreeSym = {props.DegreeSym}
            AriSignX = {props.signVals.AriSignX}
            AriSignY = {props.signVals.AriSignY}
            TauSignX = {props.signVals.TauSignX}
            TauSignY = {props.signVals.TauSignY}
            GemSignX = {props.signVals.GemSignX}
            GemSignY = {props.signVals.GemSignY}
            CanSignX = {props.signVals.CanSignX}
            CanSignY = {props.signVals.CanSignY}
            LeoSignX = {props.signVals.LeoSignX}
            LeoSignY = {props.signVals.LeoSignY}
            VirSignX = {props.signVals.VirSignX}
            VirSignY = {props.signVals.VirSignY}
            LibSignX = {props.signVals.LibSignX}
            LibSignY = {props.signVals.LibSignY}
            ScoSignX = {props.signVals.ScoSignX}
            ScoSignY = {props.signVals.ScoSignY}
            SagSignX = {props.signVals.SagSignX}
            SagSignY = {props.signVals.SagSignY}
            CapSignX = {props.signVals.CapSignX}
            CapSignY = {props.signVals.CapSignY}
            AquSignX = {props.signVals.AquSignX}
            AquSignY = {props.signVals.AquSignY}
            PisSignX = {props.signVals.PisSignX}
            PisSignY = {props.signVals.PisSignY}
            RXSym = {props.raVals.RXSym}
            MoSym = {props.moVals.MoSym}
            MoPlanetX = {props.moVals.MoPlanetX}
            MoPlanetY = {props.moVals.MoPlanetY}
            MoSign = {props.moVals.MoSign}
            MoSignSym = {props.moVals.MoSignSym}
            MoSignX = {props.moVals.MoSignX}
            MoSignY = {props.moVals.MoSignY}
            MoDegree = {props.moVals.MoDegree}
            MoDegreeX = {props.moVals.MoDegreeX}
            MoDegreeY = {props.moVals.MoDegreeY}
            MoMinute = {props.moVals.MoMinute}
            MoMinuteX = {props.moVals.MoMinuteX}
            MoMinuteY = {props.moVals.MoMinuteY}
            VeSym = {props.veVals.VeSym}
            VePlanetX = {props.veVals.VePlanetX}
            VePlanetY = {props.veVals.VePlanetY}
            VeSign = {props.veVals.VeSign}
            VeSignSym = {props.veVals.VeSignSym}
            VeSignX = {props.veVals.VeSignX}
            VeSignY = {props.veVals.VeSignY}
            VeDegree = {props.veVals.VeDegree}
            VeDegreeX = {props.veVals.VeDegreeX}
            VeDegreeY = {props.veVals.VeDegreeY}
            VeMinute = {props.veVals.VeMinute}
            VeMinuteX = {props.veVals.VeMinuteX}
            VeMinuteY = {props.veVals.VeMinuteY}
            VeRX = {props.veVals.VeRX}
            VeRXX = {props.veVals.VeRXX}
            VeRXY = {props.veVals.VeRXY}
            ASCSym = {props.ascVals.ASCSym}
            ASCPlanetX = {props.ascVals.ASCPlanetX}
            ASCPlanetY = {props.ascVals.ASCPlanetY}
            ASCSign = {props.ascVals.ASCSign}
            ASCSignSym = {props.ascVals.ASCSignSym}
            ASCSignX = {props.ascVals.ASCSignX}
            ASCSignY = {props.ascVals.ASCSignY}
            ASCDegree = {props.ascVals.ASCDegree}
            ASCDegreeX = {props.ascVals.ASCDegreeX}
            ASCDegreeY = {props.ascVals.ASCDegreeY}
            ASCMinute = {props.ascVals.ASCMinute}
            ASCMinuteX = {props.ascVals.ASCMinuteX}
            ASCMinuteY = {props.ascVals.ASCMinuteY}
            RaSym = {props.raVals.RaSym}
            RaPlanetX = {props.raVals.RaPlanetX}
            RaPlanetY = {props.raVals.RaPlanetY}
            RaSign = {props.raVals.RaSign}
            RaSignSym = {props.raVals.RaSignSym}
            RaSignX = {props.raVals.RaSignX}
            RaSignY = {props.raVals.RaSignY}
            RaDegree = {props.raVals.RaDegree}
            RaDegreeX = {props.raVals.RaDegreeX}
            RaDegreeY = {props.raVals.RaDegreeY}
            RaMinute = {props.raVals.RaMinute}
            RaMinuteX = {props.raVals.RaMinuteX}
            RaMinuteY = {props.raVals.RaMinuteY}
            RaRX = {props.raVals.RaRX}
            RaRXX = {props.raVals.RaRXX}
            RaRXY = {props.raVals.RaRXY}
            SuSym = {props.suVals.SuSym}
            SuPlanetX = {props.suVals.SuPlanetX}
            SuPlanetY = {props.suVals.SuPlanetY}
            SuSign = {props.suVals.SuSign}
            SuSignSym = {props.suVals.SuSignSym}
            SuSignX = {props.suVals.SuSignX}
            SuSignY = {props.suVals.SuSignY}
            SuDegree = {props.suVals.SuDegree}
            SuDegreeX = {props.suVals.SuDegreeX}
            SuDegreeY = {props.suVals.SuDegreeY}
            SuMinute = {props.suVals.SuMinute}
            SuMinuteX = {props.suVals.SuMinuteX}
            SuMinuteY = {props.suVals.SuMinuteY}
            ChSym = {props.chVals.ChSym}
            ChPlanetX = {props.chVals.ChPlanetX}
            ChPlanetY = {props.chVals.ChPlanetY}
            ChSign = {props.chVals.ChSign}
            ChSignSym = {props.chVals.ChSignSym}
            ChSignX = {props.chVals.ChSignX}
            ChSignY = {props.chVals.ChSignY}
            ChDegree = {props.chVals.ChDegree}
            ChDegreeX = {props.chVals.ChDegreeX}
            ChDegreeY = {props.chVals.ChDegreeY}
            ChMinute = {props.chVals.ChMinute}
            ChMinuteX = {props.chVals.ChMinuteX}
            ChMinuteY = {props.chVals.ChMinuteY}
            ChRX = {props.chVals.ChRX}
            ChRXX = {props.chVals.ChRXX}
            ChRXY = {props.chVals.ChRXY}
            MeSym = {props.meVals.MeSym}
            MePlanetX = {props.meVals.MePlanetX}
            MePlanetY = {props.meVals.MePlanetY}
            MeSign = {props.meVals.MeSign}
            MeSignSym = {props.meVals.MeSignSym}
            MeSignX = {props.meVals.MeSignX}
            MeSignY = {props.meVals.MeSignY}
            MeDegree = {props.meVals.MeDegree}
            MeDegreeX = {props.meVals.MeDegreeX}
            MeDegreeY = {props.meVals.MeDegreeY}
            MeMinute = {props.meVals.MeMinute}
            MeMinuteX = {props.meVals.MeMinuteX}
            MeMinuteY = {props.meVals.MeMinuteY}
            MeRX = {props.meVals.MeRX}
            MeRXX = {props.meVals.MeRXX}
            MeRXY = {props.meVals.MeRXY}
            JuSym = {props.juVals.JuSym}
            JuPlanetX = {props.juVals.JuPlanetX}
            JuPlanetY = {props.juVals.JuPlanetY}
            JuSign = {props.juVals.JuSign}
            JuSignSym = {props.juVals.JuSignSym}
            JuSignX = {props.juVals.JuSignX}
            JuSignY = {props.juVals.JuSignY}
            JuDegree = {props.juVals.JuDegree}
            JuDegreeX = {props.juVals.JuDegreeX}
            JuDegreeY = {props.juVals.JuDegreeY}
            JuMinute = {props.juVals.JuMinute}
            JuMinuteX = {props.juVals.JuMinuteX}
            JuMinuteY = {props.juVals.JuMinuteY}
            JuRX = {props.juVals.JuRX}
            JuRXX = {props.juVals.JuRXX}
            JuRXY = {props.juVals.JuRXY}
            UrSym = {props.urVals.UrSym}
            UrPlanetX = {props.urVals.UrPlanetX}
            UrPlanetY = {props.urVals.UrPlanetY}
            UrSign = {props.urVals.UrSign}
            UrSignSym = {props.urVals.UrSignSym}
            UrSignX = {props.urVals.UrSignX}
            UrSignY = {props.urVals.UrSignY}
            UrDegree = {props.urVals.UrDegree}
            UrDegreeX = {props.urVals.UrDegreeX}
            UrDegreeY = {props.urVals.UrDegreeY}
            UrMinute = {props.urVals.UrMinute}
            UrMinuteX = {props.urVals.UrMinuteX}
            UrMinuteY = {props.urVals.UrMinuteY}
            UrRX = {props.urVals.UrRX}
            UrRXX = {props.urVals.UrRXX}
            UrRXY = {props.urVals.UrRXY}
            ICSym = {props.icVals.ICSym}
            ICPlanetX = {props.icVals.ICPlanetX}
            ICPlanetY = {props.icVals.ICPlanetY}
            ICSign = {props.icVals.ICSign}
            ICSignSym = {props.icVals.ICSignSym}
            ICSignX = {props.icVals.ICSignX}
            ICSignY = {props.icVals.ICSignY}
            ICDegree = {props.icVals.ICDegree}
            ICDegreeX = {props.icVals.ICDegreeX}
            ICDegreeY = {props.icVals.ICDegreeY}
            ICMinute = {props.icVals.ICMinute}
            ICMinuteX = {props.icVals.ICMinuteX}
            ICMinuteY = {props.icVals.ICMinuteY}
            MCSym = {props.mcVals.MCSym}
            MCPlanetX = {props.mcVals.MCPlanetX}
            MCPlanetY = {props.mcVals.MCPlanetY}
            MCSign = {props.mcVals.MCSign}
            MCSignSym = {props.mcVals.MCSignSym}
            MCSignX = {props.mcVals.MCSignX}
            MCSignY = {props.mcVals.MCSignY}
            MCDegree = {props.mcVals.MCDegree}
            MCDegreeX = {props.mcVals.MCDegreeX}
            MCDegreeY = {props.mcVals.MCDegreeY}
            MCMinute = {props.mcVals.MCMinute}
            MCMinuteX = {props.mcVals.MCMinuteX}
            MCMinuteY = {props.mcVals.MCMinuteY}
            DSCSym = {props.dscVals.DSCSym}
            DSCPlanetX = {props.dscVals.DSCPlanetX}
            DSCPlanetY = {props.dscVals.DSCPlanetY}
            DSCSign = {props.dscVals.DSCSign}
            DSCSignSym = {props.dscVals.DSCSignSym}
            DSCSignX = {props.dscVals.DSCSignX}
            DSCSignY = {props.dscVals.DSCSignY}
            DSCDegree = {props.dscVals.DSCDegree}
            DSCDegreeX = {props.dscVals.DSCDegreeX}
            DSCDegreeY = {props.dscVals.DSCDegreeY}
            DSCMinute = {props.dscVals.DSCMinute}
            DSCMinuteX = {props.dscVals.DSCMinuteX}
            DSCMinuteY = {props.dscVals.DSCMinuteY}
            KeSym = {props.keVals.KeSym}
            KePlanetX = {props.keVals.KePlanetX}
            KePlanetY = {props.keVals.KePlanetY}
            KeSign = {props.keVals.KeSign}
            KeSignSym = {props.keVals.KeSignSym}
            KeSignX = {props.keVals.KeSignX}
            KeSignY = {props.keVals.KeSignY}
            KeDegree = {props.keVals.KeDegree}
            KeDegreeX = {props.keVals.KeDegreeX}
            KeDegreeY = {props.keVals.KeDegreeY}
            KeMinute = {props.keVals.KeMinute}
            KeMinuteX = {props.keVals.KeMinuteX}
            KeMinuteY = {props.keVals.KeMinuteY}
            KeRX = {props.keVals.KeRX}
            KeRXX = {props.keVals.KeRXX}
            KeRXY = {props.keVals.KeRXY}
            PlSym = {props.plVals.PlSym}
            PlPlanetX = {props.plVals.PlPlanetX}
            PlPlanetY = {props.plVals.PlPlanetY}
            PlSign = {props.plVals.PlSign}
            PlSignSym = {props.plVals.PlSignSym}
            PlSignX = {props.plVals.PlSignX}
            PlSignY = {props.plVals.PlSignY}
            PlDegree = {props.plVals.PlDegree}
            PlDegreeX = {props.plVals.PlDegreeX}
            PlDegreeY = {props.plVals.PlDegreeY}
            PlMinute = {props.plVals.PlMinute}
            PlMinuteX = {props.plVals.PlMinuteX}
            PlMinuteY = {props.plVals.PlMinuteY}
            PlRX = {props.plVals.PlRX}
            PlRXX = {props.plVals.PlRXX}
            PlRXY = {props.plVals.PlRXY}
            MaSym = {props.maVals.MaSym}
            MaPlanetX = {props.maVals.MaPlanetX}
            MaPlanetY = {props.maVals.MaPlanetY}
            MaSign = {props.maVals.MaSign}
            MaSignSym = {props.maVals.MaSignSym}
            MaSignX = {props.maVals.MaSignX}
            MaSignY = {props.maVals.MaSignY}
            MaDegree = {props.maVals.MaDegree}
            MaDegreeX = {props.maVals.MaDegreeX}
            MaDegreeY = {props.maVals.MaDegreeY}
            MaMinute = {props.maVals.MaMinute}
            MaMinuteX = {props.maVals.MaMinuteX}
            MaMinuteY = {props.maVals.MaMinuteY}
            MaRX = {props.maVals.MaRX}
            MaRXX = {props.maVals.MaRXX}
            MaRXY = {props.maVals.MaRXY}
            SaSym = {props.saVals.SaSym}
            SaPlanetX = {props.saVals.SaPlanetX}
            SaPlanetY = {props.saVals.SaPlanetY}
            SaSign = {props.saVals.SaSign}
            SaSignSym = {props.saVals.SaSignSym}
            SaSignX = {props.saVals.SaSignX}
            SaSignY = {props.saVals.SaSignY}
            SaDegree = {props.saVals.SaDegree}
            SaDegreeX = {props.saVals.SaDegreeX}
            SaDegreeY = {props.saVals.SaDegreeY}
            SaMinute = {props.saVals.SaMinute}
            SaMinuteX = {props.saVals.SaMinuteX}
            SaMinuteY = {props.saVals.SaMinuteY}
            SaRX = {props.saVals.SaRX}
            SaRXX = {props.saVals.SaRXX}
            SaRXY = {props.saVals.SaRXY}
            NeSym = {props.neVals.NeSym}
            NePlanetX = {props.neVals.NePlanetX}
            NePlanetY = {props.neVals.NePlanetY}
            NeSign = {props.neVals.NeSign}
            NeSignSym = {props.neVals.NeSignSym}
            NeSignX = {props.neVals.NeSignX}
            NeSignY = {props.neVals.NeSignY}
            NeDegree = {props.neVals.NeDegree}
            NeDegreeX = {props.neVals.NeDegreeX}
            NeDegreeY = {props.neVals.NeDegreeY}
            NeMinute = {props.neVals.NeMinute}
            NeMinuteX = {props.neVals.NeMinuteX}
            NeMinuteY = {props.neVals.NeMinuteY}
            NeRX = {props.neVals.NeRX}
            NeRXX = {props.neVals.NeRXX}
            NeRXY = {props.neVals.NeRXY}
            LoFoSym = {props.lofoVals.LoFoSym}
            LoFoPlanetX = {props.lofoVals.LoFoPlanetX}
            LoFoPlanetY = {props.lofoVals.LoFoPlanetY}
            LoFoSign = {props.lofoVals.LoFoSign}
            LoFoSignSym = {props.lofoVals.LoFoSignSym}
            LoFoSignX = {props.lofoVals.LoFoSignX}
            LoFoSignY = {props.lofoVals.LoFoSignY}
            LoFoDegree = {props.lofoVals.LoFoDegree}
            LoFoDegreeX = {props.lofoVals.LoFoDegreeX}
            LoFoDegreeY = {props.lofoVals.LoFoDegreeY}
            LoFoMinute = {props.lofoVals.LoFoMinute}
            LoFoMinuteX = {props.lofoVals.LoFoMinuteX}
            LoFoMinuteY = {props.lofoVals.LoFoMinuteY}

            MoBSym={props.moBVals.MoBSym}
            MoBPlanetX={props.moBVals.MoBPlanetX}
            MoBPlanetY={props.moBVals.MoBPlanetY}
            MoBSign={props.moBVals.MoBSign}
            MoBSignSym={props.moBVals.MoBSignSym}
            MoBSignX={props.moBVals.MoBSignX}
            MoBSignY={props.moBVals.MoBSignY}
            MoBDegree={props.moBVals.MoBDegree}
            MoBDegreeX={props.moBVals.MoBDegreeX}
            MoBDegreeY={props.moBVals.MoBDegreeY}
            MoBMinute={props.moBVals.MoBMinute}
            MoBMinuteX={props.moBVals.MoBMinuteX}
            MoBMinuteY={props.moBVals.MoBMinuteY}
            VeBSym={props.veBVals.VeBSym}
            VeBSign={props.veBVals.VeBSign}
            VeBPlanetX={props.veBVals.VeBPlanetX}
            VeBPlanetY={props.veBVals.VeBPlanetY}
            VeBSignSym={props.veBVals.VeBSignSym}
            VeBSignX={props.veBVals.VeBSignX}
            VeBSignY={props.veBVals.VeBSignY}
            VeBDegree={props.veBVals.VeBDegree}
            VeBDegreeX={props.veBVals.VeBDegreeX}
            VeBDegreeY={props.veBVals.VeBDegreeY}
            VeBMinute={props.veBVals.VeBMinute}
            VeBMinuteX={props.veBVals.VeBMinuteX}
            VeBMinuteY={props.veBVals.VeBMinuteY}
            VeBRX={props.veBVals.VeBRX}
            VeBRXX={props.veBVals.VeBRXX}
            VeBRXY={props.veBVals.VeBRXY}
            ASCBSym={props.ascBVals.ASCBSym}
            ASCBPlanetX={props.ascBVals.ASCBPlanetX}
            ASCBPlanetY={props.ascBVals.ASCBPlanetY}
            ASCBSign={props.ascBVals.ASCBSign}
            ASCBSignSym={props.ascBVals.ASCBSignSym}
            ASCBSignX={props.ascBVals.ASCBSignX}
            ASCBSignY={props.ascBVals.ASCBSignY}
            ASCBDegree={props.ascBVals.ASCBDegree}
            ASCBDegreeX={props.ascBVals.ASCBDegreeX}
            ASCBDegreeY={props.ascBVals.ASCBDegreeY}
            ASCBMinute={props.ascBVals.ASCBMinute}
            ASCBMinuteX={props.ascBVals.ASCBMinuteX}
            ASCBMinuteY={props.ascBVals.ASCBMinuteY}
            RaBSym={props.raBVals.RaBSym}
            RaBPlanetX={props.raBVals.RaBPlanetX}
            RaBPlanetY={props.raBVals.RaBPlanetY}
            RaBSign={props.raBVals.RaBSign}
            RaBSignSym={props.raBVals.RaBSignSym}
            RaBSignX={props.raBVals.RaBSignX}
            RaBSignY={props.raBVals.RaBSignY}
            RaBDegree={props.raBVals.RaBDegree}
            RaBDegreeX={props.raBVals.RaBDegreeX}
            RaBDegreeY={props.raBVals.RaBDegreeY}
            RaBMinute={props.raBVals.RaBMinute}
            RaBMinuteX={props.raBVals.RaBMinuteX}
            RaBMinuteY={props.raBVals.RaBMinuteY}
            RaBRX={props.raBVals.RaBRX}
            RaBRXX={props.raBVals.RaBRXX}
            RaBRXY={props.raBVals.RaBRXY}
            SuBSym={props.suBVals.SuBSym}
            SuBPlanetX={props.suBVals.SuBPlanetX}
            SuBPlanetY={props.suBVals.SuBPlanetY}
            SuBSign={props.suBVals.SuBSign}
            SuBSignSym={props.suBVals.SuBSignSym}
            SuBSignX={props.suBVals.SuBSignX}
            SuBSignY={props.suBVals.SuBSignY}
            SuBDegree={props.suBVals.SuBDegree}
            SuBDegreeX={props.suBVals.SuBDegreeX}
            SuBDegreeY={props.suBVals.SuBDegreeY}
            SuBMinute={props.suBVals.SuBMinute}
            SuBMinuteX={props.suBVals.SuBMinuteX}
            SuBMinuteY={props.suBVals.SuBMinuteY}
            ChBPlanetX={props.chBVals.ChBPlanetX}
            ChBPlanetY={props.chBVals.ChBPlanetY}
            ChBSym={props.chBVals.ChBSym}
            ChBSign={props.chBVals.ChBSign}
            ChBSignSym={props.chBVals.ChBSignSym}
            ChBSignX={props.chBVals.ChBSignX}
            ChBSignY={props.chBVals.ChBSignY}
            ChBDegree={props.chBVals.ChBDegree}
            ChBDegreeX={props.chBVals.ChBDegreeX}
            ChBDegreeY={props.chBVals.ChBDegreeY}
            ChBMinute={props.chBVals.ChBMinute}
            ChBMinuteX={props.chBVals.ChBMinuteX}
            ChBMinuteY={props.chBVals.ChBMinuteY}
            ChBRX={props.chBVals.ChBRX}
            ChBRXX={props.chBVals.ChBRXX}
            ChBRXY={props.chBVals.ChBRXY}
            MeBSym={props.meBVals.MeBSym}
            MeBPlanetX={props.meBVals.MeBPlanetX}
            MeBPlanetY={props.meBVals.MeBPlanetY}
            MeBSign={props.meBVals.MeBSign}
            MeBSignSym={props.meBVals.MeBSignSym}
            MeBSignX={props.meBVals.MeBSignX}
            MeBSignY={props.meBVals.MeBSignY}
            MeBDegree={props.meBVals.MeBDegree}
            MeBDegreeX={props.meBVals.MeBDegreeX}
            MeBDegreeY={props.meBVals.MeBDegreeY}
            MeBMinute={props.meBVals.MeBMinute}
            MeBMinuteX={props.meBVals.MeBMinuteX}
            MeBMinuteY={props.meBVals.MeBMinuteY}
            MeBRX={props.meBVals.MeBRX}
            MeBRXX={props.meBVals.MeBRXX}
            MeBRXY={props.meBVals.MeBRXY}
            JuBSym={props.juBVals.JuBSym}
            JuBPlanetX={props.juBVals.JuBPlanetX}
            JuBPlanetY={props.juBVals.JuBPlanetY}
            JuBSign={props.juBVals.JuBSign}
            JuBSignSym={props.juBVals.JuBSignSym}
            JuBSignX={props.juBVals.JuBSignX}
            JuBSignY={props.juBVals.JuBSignY}
            JuBDegree={props.juBVals.JuBDegree}
            JuBDegreeX={props.juBVals.JuBDegreeX}
            JuBDegreeY={props.juBVals.JuBDegreeY}
            JuBMinute={props.juBVals.JuBMinute}
            JuBMinuteX={props.juBVals.JuBMinuteX}
            JuBMinuteY={props.juBVals.JuBMinuteY}
            JuBRX={props.juBVals.JuBRX}
            JuBRXX={props.juBVals.JuBRXX}
            JuBRXY={props.juBVals.JuBRXY}
            UrBSym={props.urBVals.UrBSym}
            UrBPlanetX={props.urBVals.UrBPlanetX}
            UrBPlanetY={props.urBVals.UrBPlanetY}
            UrBSign={props.urBVals.UrBSign}
            UrBSignSym={props.urBVals.UrBSignSym}
            UrBSignX={props.urBVals.UrBSignX}
            UrBSignY={props.urBVals.UrBSignY}
            UrBDegree={props.urBVals.UrBDegree}
            UrBDegreeX={props.urBVals.UrBDegreeX}
            UrBDegreeY={props.urBVals.UrBDegreeY}
            UrBMinute={props.urBVals.UrBMinute}
            UrBMinuteX={props.urBVals.UrBMinuteX}
            UrBMinuteY={props.urBVals.UrBMinuteY}
            UrBRX={props.urBVals.UrBRX}
            UrBRXX={props.urBVals.UrBRXX}
            UrBRXY={props.urBVals.UrBRXY}
            ICBSym={props.icBVals.ICBSym}
            ICBPlanetX={props.icBVals.ICBPlanetX}
            ICBPlanetY={props.icBVals.ICBPlanetY}
            ICBSign={props.icBVals.ICBSign}
            ICBSignSym={props.icBVals.ICBSignSym}
            ICBSignX={props.icBVals.ICBSignX}
            ICBSignY={props.icBVals.ICBSignY}
            ICBDegree={props.icBVals.ICBDegree}
            ICBDegreeX={props.icBVals.ICBDegreeX}
            ICBDegreeY={props.icBVals.ICBDegreeY}
            ICBMinute={props.icBVals.ICBMinute}
            ICBMinuteX={props.icBVals.ICBMinuteX}
            ICBMinuteY={props.icBVals.ICBMinuteY}
            MCBSym={props.mcBVals.MCBSym}
            MCBPlanetX={props.mcBVals.MCBPlanetX}
            MCBPlanetY={props.mcBVals.MCBPlanetY}
            MCBSign={props.mcBVals.MCBSign}
            MCBSignSym={props.mcBVals.MCBSignSym}
            MCBSignX={props.mcBVals.MCBSignX}
            MCBSignY={props.mcBVals.MCBSignY}
            MCBDegree={props.mcBVals.MCBDegree}
            MCBDegreeX={props.mcBVals.MCBDegreeX}
            MCBDegreeY={props.mcBVals.MCBDegreeY}
            MCBMinute={props.mcBVals.MCBMinute}
            MCBMinuteX={props.mcBVals.MCBMinuteX}
            MCBMinuteY={props.mcBVals.MCBMinuteY}
            DSCBSym={props.dscBVals.DSCBSym}
            DSCBPlanetX={props.dscBVals.DSCBPlanetX}
            DSCBPlanetY={props.dscBVals.DSCBPlanetY}
            DSCBSign={props.dscBVals.DSCBSign}
            DSCBSignSym={props.dscBVals.DSCBSignSym}
            DSCBSignX={props.dscBVals.DSCBSignX}
            DSCBSignY={props.dscBVals.DSCBSignY}
            DSCBDegree={props.dscBVals.DSCBDegree}
            DSCBDegreeX={props.dscBVals.DSCBDegreeX}
            DSCBDegreeY={props.dscBVals.DSCBDegreeY}
            DSCBMinute={props.dscBVals.DSCBMinute}
            DSCBMinuteX={props.dscBVals.DSCBMinuteX}
            DSCBMinuteY={props.dscBVals.DSCBMinuteY}
            KeBSym={props.keBVals.KeBSym}
            KeBPlanetX={props.keBVals.KeBPlanetX}
            KeBPlanetY={props.keBVals.KeBPlanetY}
            KeBSign={props.keBVals.KeBSign}
            KeBSignSym={props.keBVals.KeBSignSym}
            KeBSignX={props.keBVals.KeBSignX}
            KeBSignY={props.keBVals.KeBSignY}
            KeBDegree={props.keBVals.KeBDegree}
            KeBDegreeX={props.keBVals.KeBDegreeX}
            KeBDegreeY={props.keBVals.KeBDegreeY}
            KeBMinute={props.keBVals.KeBMinute}
            KeBMinuteX={props.keBVals.KeBMinuteX}
            KeBMinuteY={props.keBVals.KeBMinuteY}
            KeBRX={props.keBVals.KeBRX}
            KeBRXX={props.keBVals.KeBRXX}
            KeBRXY={props.keBVals.KeBRXY}
            PlBSym={props.plBVals.PlBSym}
            PlBPlanetX={props.plBVals.PlBPlanetX}
            PlBPlanetY={props.plBVals.PlBPlanetY}
            PlBSign={props.plBVals.PlBSign}
            PlBSignSym={props.plBVals.PlBSignSym}
            PlBSignX={props.plBVals.PlBSignX}
            PlBSignY={props.plBVals.PlBSignY}
            PlBDegree={props.plBVals.PlBDegree}
            PlBDegreeX={props.plBVals.PlBDegreeX}
            PlBDegreeY={props.plBVals.PlBDegreeY}
            PlBMinute={props.plBVals.PlBMinute}
            PlBMinuteX={props.plBVals.PlBMinuteX}
            PlBMinuteY={props.plBVals.PlBMinuteY}
            PlBRX={props.plBVals.PlBRX}
            PlBRXX={props.plBVals.PlBRXX}
            PlBRXY={props.plBVals.PlBRXY}
            MaBSym={props.maBVals.MaBSym}
            MaBPlanetX={props.maBVals.MaBPlanetX}
            MaBPlanetY={props.maBVals.MaBPlanetY}
            MaBSign={props.maBVals.MaBSign}
            MaBSignSym={props.maBVals.MaBSignSym}
            MaBSignX={props.maBVals.MaBSignX}
            MaBSignY={props.maBVals.MaBSignY}
            MaBDegree={props.maBVals.MaBDegree}
            MaBDegreeX={props.maBVals.MaBDegreeX}
            MaBDegreeY={props.maBVals.MaBDegreeY}
            MaBMinute={props.maBVals.MaBMinute}
            MaBMinuteX={props.maBVals.MaBMinuteX}
            MaBMinuteY={props.maBVals.MaBMinuteY}
            MaBRX={props.maBVals.MaBRX}
            MaBRXX={props.maBVals.MaBRXX}
            MaBRXY={props.maBVals.MaBRXY}
            SaBSym={props.saBVals.SaBSym}
            SaBPlanetX={props.saBVals.SaBPlanetX}
            SaBPlanetY={props.saBVals.SaBPlanetY}
            SaBSign={props.saBVals.SaBSign}
            SaBSignSym={props.saBVals.SaBSignSym}
            SaBSignX={props.saBVals.SaBSignX}
            SaBSignY={props.saBVals.SaBSignY}
            SaBDegree={props.saBVals.SaBDegree}
            SaBDegreeX={props.saBVals.SaBDegreeX}
            SaBDegreeY={props.saBVals.SaBDegreeY}
            SaBMinute={props.saBVals.SaBMinute}
            SaBMinuteX={props.saBVals.SaBMinuteX}
            SaBMinuteY={props.saBVals.SaBMinuteY}
            SaBRX={props.saBVals.SaBRX}
            SaBRXX={props.saBVals.SaBRXX}
            SaBRXY={props.saBVals.SaBRXY}
            NeBSym={props.neBVals.NeBSym}
            NeBPlanetX={props.neBVals.NeBPlanetX}
            NeBPlanetY={props.neBVals.NeBPlanetY}
            NeBSign={props.neBVals.NeBSign}
            NeBSignSym={props.neBVals.NeBSignSym}
            NeBSignX={props.neBVals.NeBSignX}
            NeBSignY={props.neBVals.NeBSignY}
            NeBDegree={props.neBVals.NeBDegree}
            NeBDegreeX={props.neBVals.NeBDegreeX}
            NeBDegreeY={props.neBVals.NeBDegreeY}
            NeBMinute={props.neBVals.NeBMinute}
            NeBMinuteX={props.neBVals.NeBMinuteX}
            NeBMinuteY={props.neBVals.NeBMinuteY}
            NeBRX={props.neBVals.NeBRX}
            NeBRXX={props.neBVals.NeBRXX}
            NeBRXY={props.neBVals.NeBRXY} 
            RXBSym={props.RXBSym}
            LoFoBSym={props.lofoBVals.LoFoBSym}
            LoFoBPlanetX={props.lofoBVals.LoFoBPlanetX}
            LoFoBPlanetY={props.lofoBVals.LoFoBPlanetY}
            LoFoBSign={props.lofoBVals.LoFoBSign}
            LoFoBSignSym={props.lofoBVals.LoFoBSignSym}
            LoFoBSignX={props.lofoBVals.LoFoBSignX}
            LoFoBSignY={props.lofoBVals.LoFoBSignY}
            LoFoBDegree={props.lofoBVals.LoFoBDegree}
            LoFoBDegreeX={props.lofoBVals.LoFoBDegreeX}
            LoFoBDegreeY={props.lofoBVals.LoFoBDegreeY}
            LoFoBMinute={props.lofoBVals.LoFoBMinute}
            LoFoBMinuteX={props.lofoBVals.LoFoBMinuteX}
            LoFoBMinuteY={props.lofoBVals.LoFoBMinuteY}
         
/>

        </div>
    </>
        
    )  
    
}



